import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NonValidatedPersonalInfo } from "../models/non-validated-personal-info";
import { PersonalInfo } from "../models/personal-info.model";
@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") private baseUrl: string
  ) {}

  isIPAllowed(): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + "api/auth/ip-allowed");
  }

  savePersonalInfo(personalInfoDetails: PersonalInfo) {
    console.log('Saving Personal Info: ', personalInfoDetails);

    return this.http.post<NonValidatedPersonalInfo>(
      this.baseUrl + "api/auth/",
      personalInfoDetails
    );
  }
}
